/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.TicketDetailsResponse, (params: vp.TicketDetialRequest) => void, () => void];

function useFetchTicketDetails({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.TicketDetialRequest>();
  const [response, setResponse] = useState<vp.TicketDetailsResponse>({
    Success: false,
    ErrorMessage: '',
    Ticket: {
      dateAdded: '',
      lastUpdated: '',
      id: '',
      status: '',
      subject: '',
      description: '',
      author: '',
      ticketComments: [],
    },
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.TicketDetialRequest) => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');

      const res = await api.fetchTicketDetails(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: vp.TicketDetialRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Ticket: {
          dateAdded: '',
          lastUpdated: '',
          id: '',
          status: '',
          subject: '',
          description: '',
          ticketComments: [],
          author: '',
        },
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchTicketDetails);
